export default __webpack_public_path__ + "static/media/confirm-guy.a3e9f8a8.png";